export const Footer = () => {
  return (
    <footer className="flex shrink basis-44 flex-col items-center justify-center px-4 py-10 ">
      <p className="opacity-50">
        Created by{' '}
        <a
          href="https://matthewarthur.dev/"
          className="underline"
          target="_blank"
        >
          Matthew Arthur
        </a>
      </p>
    </footer>
  );
};
